import { setTimelineChronologySelectedEntryIds, TimelineChronologyType } from '@/store';
import { TIMELINE_CHRONOLOGY_TAGS } from '../constants';
import { api } from '../core';

export type ChronologyEntryDeleteResponse = object;

interface ChronologyEntryDeleteProps {
  caseId: string;
  entryIds: string[];
}

const chronologyEntryDeleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postChronologyEntryDelete: builder.query<ChronologyEntryDeleteResponse, ChronologyEntryDeleteProps>({
      query: ({ caseId, entryIds }: ChronologyEntryDeleteProps) => ({
        url: `chronology/entry/delete`,
        method: 'POST',
        body: {
          case_id: caseId,
          chronology_entry_ids: entryIds,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(
            setTimelineChronologySelectedEntryIds({
              key: TimelineChronologyType.CHRONOLOGY,
              data: [],
            }),
          );
          dispatch(api.util.invalidateTags([...TIMELINE_CHRONOLOGY_TAGS]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postTimelineEntryDelete in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostChronologyEntryDeleteQuery } = chronologyEntryDeleteApi;
